import SubjectDashboard from "../subjects-management/dashboard/subject-dashboard";
import { MainLayoutV2 } from "../../components/main-layout-v2/main-layout-v2";
import { MainNavigation } from "../../components/main-navigation/main-navigation";
import { Body } from "../../components/main-body/body";
import { useEffect, useMemo, useState, useRef } from "react";
import ApiSubjectsDashboard from "../../api/subjects-dashboard";
import DropdownFilters from "../../components/dropdown-filters/dropdown-filters";
import moment from "moment";
import ApiSubjectsManagement from "../../api/subjects-manager";
import { useSelector } from "react-redux";
import { selectSettings } from "../../store/slices/settings";
import { selectCurrentProject } from "../../store/slices/projects";

const Dashboard = () => {
  const [cohortsList, setCohortsList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const settings = useSelector(selectSettings);
  const isSitesEnabled = settings?.find((s) => s.key === "sitesEnable")?.value === true;
  const getDashboardFilterItems = () => {
    ApiSubjectsDashboard.filterField().then((r) => {
      setCohortsList(r.data.cohorts?.map((c) => ({ id: c.id, name: c.value })));
      setSitesList(r.data.sites?.map((c) => ({ id: c.id, name: c.name })));
    });
  };
  const project = useSelector(selectCurrentProject);
  const fetchSubjectList = async () => {
    ApiSubjectsManagement.getSubjectsSimple().then((r) => {
      setSubjectList(
        r.data.subjects.map((s) => ({
          id: s.id,
          name: s.displayId,
        }))
      );
    });
  };

  useEffect(() => {
    if (!project?.id) return;

    setCohortsList([]);
    setSitesList([]);
    setSubjectList([]);

    const reset = { period: [{ start: defaultStartDate, end: defaultEndDate }] };
    setDashboardFilter(reset);
    prevDashboardFilterRef.current = reset;

    fetchSubjectList();
    getDashboardFilterItems();
  }, [project?.id]);

  // useEffect(() => {
  //   fetchSubjectList();
  //   getDashboardFilterItems();
  // }, []);

  const defaultStartDate = moment.utc().subtract(30, "days").startOf("day").toISOString();
  const defaultEndDate = moment.utc().endOf("day").toISOString();

  const filterItems = [
    { name: "Subject", id: "subjectIds", children: subjectList },
    { name: "Cohorts", id: "cohortIds", children: cohortsList },
    ...(isSitesEnabled
      ? [{ name: "Sites", id: "siteIds", children: sitesList }]
      : []),
    {
      name: "Period",
      id: "period",
      period: true,
      defaultValue: [{ start: defaultStartDate, end: defaultEndDate }],
    },
  ];

  const [dashboardFilter, setDashboardFilter] = useState({
    period: [{ start: defaultStartDate, end: defaultEndDate }],
  });

  const prevDashboardFilterRef = useRef(dashboardFilter);

  const updateFilterValue = (newValue) => {
    const prevFilter = prevDashboardFilterRef.current;
    const isEmptyCohortsAdded =
      Array.isArray(newValue.cohortIds) &&
      newValue.cohortIds.length === 0 &&
      (!prevFilter.cohortIds || prevFilter.cohortIds.length === 0);
    const areFiltersEqual = JSON.stringify(newValue) === JSON.stringify(prevFilter);
    if (isEmptyCohortsAdded || areFiltersEqual) {
      return;
    }

    setDashboardFilter(newValue);
    prevDashboardFilterRef.current = structuredClone(newValue);
  };

  const headerFilter = useMemo(
    () => (
      <DropdownFilters
        filtersBy={filterItems}
        updateFilterValue={updateFilterValue}
        filter={dashboardFilter}
        key={`filters-${project?.id || 'none'}`}
      />
    ),
    [cohortsList, dashboardFilter, isSitesEnabled, project?.id]
  );

  return (
    <MainLayoutV2 key={`layout-${project?.id || 'none'}`}>
      <MainNavigation />
      <Body
        scroll
        header={{ title: "Summary dashboard", isBold: true }}
        filters={headerFilter}
      >
        <SubjectDashboard
          filterOptions={dashboardFilter}
          key={`subject-dash-${project?.id || 'none'}`}
        />
      </Body>
    </MainLayoutV2>
  );
};

export default Dashboard;
